export const actionTypes = {
  fetch_request: "FETCH_REQUEST",
  fetch_success: "FETCH_SUCCESS",
  fetch_error: "FETCH_ERROR",
  fetch_trending_movies: "FETCH_TRENDING_MOVIES",
  fetch_queried_movie: "FETCH_QUERIED_MOVIE",
  fetch_anime: "FETCH_ANIME",
};
